import React, { useEffect, useState } from 'react';
import './page.css';
import './table.css';
import { makeStyles } from '@material-ui/core/styles';
import ReactECharts from 'echarts-for-react';
import { resolveDate } from '../../../../configs/helpers/utility';

const useStyles = makeStyles((theme) => ({
   graphsContainer: {
      width: '100%',
   },
}));

const PDFCSS = () => {
   const classes = useStyles();
   const [filtersData, setFiltersData] = useState();
   const [chartData, setChartData] = useState();
   const [MultiTable, setMultiTable] = useState();
   useEffect(() => {
      let report = localStorage.getItem('report');
      if (report) {
         let { filtersData, chartData, MultiTable } = JSON.parse(report);
         setFiltersData(filtersData);
         setChartData(chartData);
         setMultiTable(MultiTable);
         window.print();
      }
      return () => {
         localStorage.removeItem('report');
      };
   }, []);
   const getChartsOptionsDefault = () => {
      let option = {
         animation: false,
         animationDuration: 0,
         gradientColor: ['#defffd', '#96f6ff', '#00eaff'],
         tooltip: {
            position: 'top',
         },
         grid: {
            top: 10,
            left: 10,
            right: 10,
            bottom: 10,
            containLabel: true,
         },
         xAxis: {
            type: 'category',
            data: null,
            splitArea: {
               show: true,
            },
            axisLabel: { rotate: 90 },
         },
         yAxis: {
            type: 'category',
            data: null,
            splitArea: {
               show: true,
            },
         },
         visualMap: {
            show: false,
            min: 0,
            max: 10,
            calculable: true,
            orient: 'horizontal',
            left: 'center',
            bottom: '5%',
         },
         series: [
            {
               name: 'Punch Card',
               type: 'heatmap',
               data: null,
               label: {
                  show: true,
               },
               emphasis: {
                  itemStyle: {
                     shadowBlur: 10,
                     shadowColor: 'rgba(0, 0, 0, 0.5)',
                  },
               },
            },
         ],
      };
      return option;
   };
   const mapOptions = (data) => {
      let days = data.map(
         (el) => `${el.dateInWeek}, ${el.dateTimeLabel.split(' ')[0]}`,
      );

      let hours = data[0].data.map(
         (el) => `${el.startHourLabel}-${el.endHourLabel}`,
      );

      let index = 0;
      let restructureData = [];
      data.forEach((element) => {
         element.data.forEach((el) => {
            restructureData[index++] = el.count;
         });
      });

      let temp = [[]];
      let dayCount = 1;
      let hrsCount = 0;
      for (let i = 1; i <= data.length * 24; i++) {
         temp[i - 1] = [dayCount - 1, hrsCount, restructureData[i - 1]];
         hrsCount += 1;
         if (i % 24 === 0) {
            dayCount += 1;
         }
         if (hrsCount === 24) {
            hrsCount = 0;
         }
      }

      const dataMapped = temp.map(function (item) {
         return [item[1], item[0], item[2] || '-'];
      });

      let option = getChartsOptionsDefault();
      option.visualMap.min = Math.min(...restructureData);
      option.visualMap.max = Math.max(...restructureData);
      option.series[0].data = dataMapped;
      option.yAxis.data = days;
      option.xAxis.data = hours;

      return option;
   };
   const costFormat = (value) => {
      return value && new Intl.NumberFormat().format(value);
   };
   return (
      <div className='book'>
         <div className='page' id='1'>
            <div className='subpage'>
               <div className='title'>แสดงจำนวนผู้เข้าใช้งาน</div>
               <div className='sub-title'>ตัวกรอง</div>
               <div>
                  <div>
                     เริ่มต้น:{' '}
                     {(filtersData &&
                        resolveDate(filtersData.startDateString)) ||
                        '-'}
                  </div>
                  <div>
                     สิ้นสุด:{' '}
                     {(filtersData && resolveDate(filtersData.endDateString)) ||
                        '-'}
                  </div>
               </div>
               <div className='sub-title'>กราฟ</div>
               <div className={classes.graphsContainer}>
                  {chartData && (
                     <ReactECharts
                        option={mapOptions(chartData)}
                        style={{ height: 300, width: '100%' }}
                     />
                  )}
               </div>
               <div style={{ marginTop: '10px' }}>
                  {MultiTable && (
                     <div>
                        <div className='title'>{MultiTable[0].listName}</div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>รายชื่อ</th>
                              <th>คะแนน</th>
                           </tr>
                           {MultiTable[0].points.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.name}</td>
                                 <td class='text-right'>
                                    {costFormat(item.points)}
                                 </td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

export default PDFCSS;
